<div class="btn-share-wrapper {{class}}">
  <h5>Compartir:</h5>
  <a class="btn-share facebook" target="_blank" href="https://www.facebook.com/sharer/sharer.php?u={{route.link}}">

  </a>
 <a class="btn-share twitter" target="_blank"
    href="http://twitter.com/share?text={{name}}&url={{route.link}}&hashtags=WWF,wwfbolivia">
  </a>
  <a class="btn-share share" (click)="route.copiShareLink()">

  </a>
</div>
